import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from 'src/app/services/breadcrumb.service';
import { IBreadCrumb } from 'src/app/data-models/Ibreadcrumb.interface';

@Component({
  selector: 'app-howto',
  templateUrl: './howto.component.html',
  styleUrls: ['./howto.component.css']
})
export class HowtoComponent implements OnInit {

  constructor(
    private breadCrumbsService : BreadcrumbsService
  ) { }

  ngOnInit() {
    this.updateBreadCrumbs();
  }

  updateBreadCrumbs()
  {
    let newBreadCrumbs : Array<IBreadCrumb> = new Array();

    newBreadCrumbs.push({
      label: "How to",
      path: "/howto",
      active: true
    })

    this.breadCrumbsService.breadcrumbs.next(newBreadCrumbs);
  }

}
